import _styled, { useTheme } from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
export const Spacer = () => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(_StyledSpan, {
    "aria-hidden": "true",
    $_css: theme.textLight,
    children: "|"
  });
};
var _StyledSpan = _styled("span").withConfig({
  displayName: "Spacer___StyledSpan",
  componentId: "sc-zz94td-0"
})(p => ({
  color: p.$_css
}));